import { observer, inject } from 'mobx-react';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import ShellRouter from 'routes/ShellRouter';

import './Shell.scss';

@withRouter
@inject('userStore')
@observer
class Shell extends Component {
  render() {
    return <div className="shell">{this.props.userStore.isInfoLoaded && <ShellRouter />}</div>;
  }
}

export default Shell;



// WEBPACK FOOTER //
// ./src/containers/Shell/Shell.jsx